// extracted by mini-css-extract-plugin
export default {"container":"aQp4-","skeleton-progress":"BvdrE"};